import { Route, Switch } from "react-router-dom";

import ChooseWhenToPayPage from "@faire/prototype-playground/workspace/rp/auto-switch-to-terms";
import NetTermsUpsellAtCheckoutPage from "@faire/prototype-playground/workspace/rp/net-terms-upsell";

export function RiyaPathakRoutes() {
  return (
    <Switch>
      <Route path="/rp/auto-switch-to-terms" component={ChooseWhenToPayPage} />
      <Route path="/rp/net-terms-upsell" component={NetTermsUpsellAtCheckoutPage} />
    </Switch>
  );
}

export const slug = "rp";
